import React, { useState, useEffect, useRef } from "react";
import tw from "twin.macro";
import { SectionHeading } from "../misc/Headings";
import { useLanguage } from "../../helpers/languageSelector"; // Make sure this is correctly imported
import client from 'sanityClient'; // Import the Sanity client


const Container = tw.div`relative -mt-12`;
const Content = tw.div`max-w-screen-xl mx-auto py-6 lg:py-8`;
const HeadingWithControl = tw.div`flex flex-col items-center sm:items-stretch sm:flex-row justify-center`; 
const Heading = tw(SectionHeading)`pb-8 text-center`; 

export default () => {
  const { currentLanguage } = useLanguage();
  const [content, setContent] = useState({ heading: '' });
  const [isVisible, setIsVisible] = useState(true);
  const widgetContainerRef = useRef(null);

  useEffect(() => {
    // Fetch content based on the current language
    client.fetch(`*[_type == "socials" && language == "${currentLanguage}"][0]`)
      .then((data) => {
        setContent({
          heading: data.heading,
        });
      })
      .catch((error) => console.error('Error fetching data:', error));
  }, [currentLanguage]);

  useEffect(() => {
    // Keep visible by default; only hide after we are sure there is no media
    setIsVisible(true);

    const hasMediaInBehold = () => {
      const host = widgetContainerRef.current;
      if (!host) return false;
      const widget = host.querySelector('behold-widget');
      if (!widget) return false;

      // Traverse shadow DOM: widget -> behold-grid -> posts
      const widgetRoot = widget.shadowRoot;
      if (!widgetRoot) return false;
      const grid = widgetRoot.querySelector('behold-grid');
      if (!grid) return false;
      const gridRoot = grid.shadowRoot;
      if (!gridRoot) return false;

      // Look for media elements inside the grid's shadow root
      const media = gridRoot.querySelector(
        'behold-image, behold-video, behold-image-post, behold-video-post, figure.posts .post'
      );
      return Boolean(media);
    };

    // Poll for a short window to allow the widget to initialize and load
    const start = Date.now();
    const maxWaitMs = 8000;
    const intervalMs = 400;
    const intervalId = setInterval(() => {
      if (hasMediaInBehold()) {
        setIsVisible(true);
        clearInterval(intervalId);
      } else if (Date.now() - start > maxWaitMs) {
        // After waiting enough and still no media, hide the socials
        setIsVisible(false);
        clearInterval(intervalId);
      }
    }, intervalMs);

    return () => clearInterval(intervalId);
  }, [currentLanguage]);

  return (
    isVisible ? (
      <Container>
        <Content>
          <HeadingWithControl>
            <Heading>{content.heading}</Heading>
          </HeadingWithControl>
          <div ref={widgetContainerRef}>
            {/* Behold widget for social media feed */}
            <behold-widget feed-id="w24j2UYTBcCO0ofz7CHu"></behold-widget>
            <script>
              {
                (() => {
                  const d=document,s=d.createElement("script");s.type="module";
                  s.src="https://w.behold.so/widget.js";d.head.append(s);
                })()
              }
            </script>
          </div>
        </Content>
      </Container>
    ) : null
  );
};
